import { BREAKPOINTS } from '../../model/model';
import { BOARD } from '../../model/msg/board';
import { isIOS, isAndroid, isDefined, isString, not, isNotDefined, anyOf, parseInt10, each, getFileExtension, getUriParams, getObjForPagination } from '../../utils/util';
import { getDatasWithOption } from '../../utils/service';

class Wallpaper {
  constructor(options) {
    const _ = this;

    // const
    _.IMAGEVIEWER_ID = 'imageviewer-rwd';
    _.LIST_NUM_PER_PAGE = 12;
    _.PAGINATION_BTN_DISPLAY_NUM = 5;
    _.DEFAULT_IMG_SIZE = {width: 1024, height: 768};

    // variables
    _.option = $.extend({
      wrap: null,
      apiDomain: '',
      breakpoint: BREAKPOINTS,
      global: window
    }, options);

    _.contiGroupData = [];
    _.data = null;

    _.imgObjs = [];

    _.global = (_.option.global) ? _.option.global : window;

    _.wrap = null;
    _.imageViewer = null;
    _.imageViewerWrap = null;

    _.currentIndex = 0;
    _.currentPageIndex = 0;

    _.msg = {
      FAIL_LOAD_WALLPAPER_DATA: '월페이퍼 데이터를 불러올 수 없습니다. 잠시 후, 다시 시도해주세요.'
    };
  }

  /*
   * public methods
   */
  init() {
    const _ = this;

    _.wrap = _.option.wrap;

    getDatasWithOption([{
      type: 'GET',
      url: _.option.apiDomain +'/conti/getContentGroup?service=lineage&groupAlias=lineage-wallpaper&subAlias=ko-KR',
      dataType: 'json',
      contentType: 'application/json',
      Accept: 'application/json'
    }], (data) => {
      if(not(Array.isArray)(data) || data.length <= 0) {
        _.setNoData();
      } else {
        data.forEach(item => {
          _.contiGroupData.push(JSON.parse(item.jsonData));
        });
        console.log( ' success _.contiGroupData : ', _.contiGroupData );
        _.setData(_.contiGroupData.reverse());
        _.setInstance();
      }
    }, (data) => {
      _.global.alert(_.msg.FAIL_LOAD_WALLPAPER_DATA); // '월페이퍼 데이터를 불러올 수 없습니다. 잠시 후, 다시 시도해주세요.'
    });

    return _;
  }

  setNoData() {
    const itemListWrap = $('> ul', this.wrap);
    itemListWrap.empty().append(`<li class="nodata">${BOARD.NO_ITEM}</li>`);
  }

  setData(data) {
    const _ = this;

    let items = [];
    each(data, function (group) {
      if (Array.isArray(group.groups) && group.groups.length > 0) {
        each(group.groups, function (item) {
          items.push(item);
        });
      }
    });

    _.data = items;

    // set _.imgObjs
    let imgObj;
    each(items, function (item) {
      imgObj = item.img;
      // if (!imgObj.thumbnailSrc) imgObj.thumbnailSrc = imgObj.src;
      if (anyOf(isNotDefined(imgObj.width), imgObj.width <= 0)) imgObj.width = _.DEFAULT_IMG_SIZE.width;
      if (anyOf(isNotDefined(imgObj.height), imgObj.height <= 0)) imgObj.height = _.DEFAULT_IMG_SIZE.height;

      _.imgObjs.push({
        src: imgObj.src || '',
        w: parseInt10(imgObj.width),
        h: parseInt10(imgObj.height)
      });
    });
  }

  setInstance() {
    const _ = this,
      locationParams = getUriParams(_.global.location.href);

    _.currentPageIndex = parseInt10(((!locationParams || !locationParams.page) ? 1 : locationParams.page));

    _.setList(_.LIST_NUM_PER_PAGE, _.currentPageIndex);

    _.setPagination(_.data.length, _.LIST_NUM_PER_PAGE, _.PAGINATION_BTN_DISPLAY_NUM, _.currentPageIndex);
  }

  setList(listNumPerPage, pageIndex) {
    const _ = this;

    let tpl = '';

    let totalPageNum = Math.ceil(_.data.length / listNumPerPage); // 8
    if (pageIndex < 1) pageIndex = 1;
    if (pageIndex > totalPageNum) pageIndex = totalPageNum;
    let firstItemIndex = (listNumPerPage * (pageIndex - 1)) + 1;

    let item, imgObj, count = 1;
    for (let i = firstItemIndex, max = firstItemIndex + listNumPerPage; i < max; i++) {
      item = _.data[i - 1];

      if (isNotDefined(item)) break;

      imgObj = item.img || {};
      // if (!imgObj.thumbnailSrc) imgObj.thumbnailSrc = imgObj.src;

      tpl += `<li class="no${count}" data-index="${i}">
                <div class="thumb" style="background-image:url(${imgObj.src});"></div>
              </li>`;

      count++;
    }

    const itemListWrap = $('> ul', _.wrap);
    itemListWrap.empty().append(tpl);

    // set events
    $('li', itemListWrap).on('click', function (evt) {
      let btn = $(this),
        index = parseInt10(btn.attr('data-index'));

      _.setImageViewer(_.imgObjs, index);
      _.setImageViewerBtns(index);

      _.currentIndex = index;
    });
  }

  setPagination(totalItemsLength, listNumPerPage, displayPaginationBtnLength, pageIndex) {
    const _ = this;

    let paginationObj = getObjForPagination(totalItemsLength, listNumPerPage, displayPaginationBtnLength, pageIndex);

    pageIndex = paginationObj.pageIndex;

    let tpl = '';
    if (paginationObj.prevPageIndex > 0) {
      tpl += `<li class="prev">
                <a href="?page=${paginationObj.prevPageIndex}" data-paging="${paginationObj.prevPageIndex}">
                  <i class="fe-icon-paging-prev"></i>
                </a>
              </li>`;
    }

    for (let i = paginationObj.firstPageIndex, max = paginationObj.lastPageIndex; i <= max; i++) {
      if (i === pageIndex) {
        tpl += `<li class="current">${i}</li>`;

      } else {
        tpl += `<li><a href="?page=${i}" data-paging="${i}">${i}</a></li>`;
      }
    }

    if (paginationObj.nextPageIndex > 0) {
      tpl += `<li class="next">
                <a href="?page=${paginationObj.nextPageIndex}" data-paging="${paginationObj.nextPageIndex}">
                  <i class="fe-icon-paging-next"></i>
                </a>
              </li>`;
    }

    let paginationBtnsWrap = $('.pagination-container .pagination-list');
    paginationBtnsWrap.empty().append(tpl);
  }

  setImageViewer(imgObjs, index) {
    const _ = this;

    if (isNotDefined(_.imageViewer)) {
      _.imageViewer = new nc.ui.ImageViewerRWD($('body'), imgObjs, {
        // - custom options
        // originViewerUrl: 'http://m.lineage2.plaync.com/board/result/viewimage?imgSrc=',
        // commentUrl: 'http://m.lineage2.plaync.com/board/image/commentList?articleId=606818',
        isPreloadImages: false,
        id: _.IMAGEVIEWER_ID,
        // topBarTitle: '',
        hasDownloadFileBtn: true,
        hasOpenImageInPopupBtn: true,
        readyCallback: function () {
          console.log('init imageViewer complete');
        },

        // - photoswipe library base options - http://photoswipe.com/documentation/options.html
        photoswipe: {
          // arrowEl: true, ...

          // TODO - change
          // errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>'
        }
      });

      _.imageViewerWrap = $('#' + _.IMAGEVIEWER_ID);
    }
    _.imageViewer.slideByUrl(index - 1);

    _.imageViewer.listen('afterChange', function () {
      const index = _.imageViewer.getCurrentIndex() + 1;
      _.setImageViewerBtns(index);
    });
  }

  setImageViewerBtns(index) {
    const _ = this,
      item = _.data[index - 1] || {},
      isExistItemImgSrc = (isDefined(item.img) && isString(item.img.src)),
      downloadBtn = $('.pswp__button--download', _.imageViewerWrap), // show on desktop by css
      popupBtn = $('.pswp__button--open-image-popup', _.imageViewerWrap); // show on iOS, android device by css

    downloadBtn.attr('href', '#');
    popupBtn.attr('href', '#');

    if (isIOS(navigator.userAgent)) {
      // iOS device. hide download btn. show popupBtn.
      downloadBtn.hide();
      popupBtn.show();

      if (isExistItemImgSrc) _.setImageViewerOpenImagePopupBtnHref(item.img.src);

    } else if (isAndroid(navigator.userAgent)) {
      // android device.
      console.log('android');

      if (/jpg|jpeg|png|gif/.test(getFileExtension(item.img.src))) {
        downloadBtn.hide();
        popupBtn.show();

        if (isExistItemImgSrc) _.setImageViewerOpenImagePopupBtnHref(item.img.src);

      } else {
        downloadBtn.show();
        popupBtn.hide();

        if (isExistItemImgSrc) _.setImageViewerDownloadBtnHref(item.img.src);
      }

    } else {
      // desktop
      downloadBtn.show();
      popupBtn.hide();

      const href = item.downloadFileUrl || '';
      if (href) downloadBtn.attr('href', href.trim());
    }
  }

  setImageViewerOpenImagePopupBtnHref(src) {
    const _ = this,
      popupBtn = $('.pswp__button--open-image-popup', _.imageViewerWrap); // show on iOS, android device by css

    popupBtn.attr('href', src || '');

    popupBtn
      .off('click.ui.popup')
      .on('click.ui.popup', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();

        _.global.open(src);
      });
  }

  setImageViewerDownloadBtnHref(src) {
    const _ = this,
      downloadBtn = $('.pswp__button--download', _.imageViewerWrap);

    downloadBtn.attr('href', (src || ''));
  }
}

export default Wallpaper;


// WEBPACK FOOTER //
// ./_src/js/download/wallpaper/Wallpaper.js